import React from 'react';
import Tippy from '@tippyjs/react';
import { CircleStackIcon } from '@heroicons/react/20/solid';

import styles from './ProductSource.module.scss';
import { Pill } from '@nearst/ui';

const ProductSource = ({ stockItem }) => {
	const hasAnyProductData = stockItem?.title || stockItem?.brand || stockItem?.description || stockItem?.images?.length > 0;
	if (!hasAnyProductData || !stockItem?.productSource) return null;

	let displayName, description;
	switch (stockItem?.productSource) {
		case 'csv':
			displayName = 'Your POS';
			description = 'Product data sourced from your POS system';
			break;
		case 'myshop':
			displayName = 'Dashboard';
			description = 'Product data added through the NearSt dashboard';
			break;
		case 'brandbank':
			displayName = 'Brandbank';
			description = 'Product data sourced from NIQ Brandbank';
			break;
		default:
			displayName = 'NearSt Library';
			description =
				"Product data sourced from NearSt's global library and used for non-Google channels. Google sources its own product data directly, so this information isn't sent to Google";
	}

	return (
		<Tippy className={styles.tooltip} content={description} placement="bottom">
			<div className={styles.productSource}>
				<Pill colour="grey">
					<CircleStackIcon /> {displayName}
				</Pill>
			</div>
		</Tippy>
	);
};

export default ProductSource;
